import axios from "axios";

// const
const APPLICATION_VERIFY_UPDATE_DATA = "applicationVerify/APPLICATION_VERIFY_UPDATE_DATA";
const APPLICATION_VERIFY_STORE_APPLICATIONS = "applicationVerify/APPLICATION_VERIFY_STORE_APPLICATIONS";
const APPLICATION_VERIFY_STORE_VERSIONS = "applicationVerify/APPLICATION_VERIFY_STORE_VERSIONS";
const APPLICATION_VERIFY_TOGGLE_MODAL = "applicationVerify/APPLICATION_VERIFY_TOGGLE_MODAL";
const APPLICATION_VERIFY_TOGGLE_LOADING = "applicationVerify/APPLICATION_VERIFY_TOGGLE_LOADING";

const APPLICATION_VERIFY_MODAL_SUCCESS_TITLE = "scenes_Application_ApplicationVerify_modal_success_title";
const APPLICATION_VERIFY_MODAL_FAIL_TITLE = "scenes_Application_ApplicationVerify_modal_fail_title";
const APPLICATION_VERIFY_MODAL_AUDIT_SUCCESS_CONTENT = "scenes_Application_ApplicationVerify_modal_auditSuccess_content";
const APPLICATION_VERIFY_MODAL_AUDIT_FAIL_CONTENT = "scenes_Application_ApplicationVerify_modal_auditFail_content";
const APPLICATION_VERIFY_MODAL_OK_LABEL = "scenes_Application_ApplicationVerify_modal_OK_label";
const APPLICATION_VERIFY_MODAL_CANCEL_LABEL = "scenes_Application_ApplicationVerify_modal_cancel_label";

// reducer
export const applicationVerifyPlatform = (state = {

  loading: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  messageInfo: {},

  name: "",
  selectedApp: "",
  applications: [],
  showApplications: [],
  appInfo: {},
  selectedVersion: "",
  versions: [],
  showVersions: [],
}, action) => {
  switch (action.type) {
    case APPLICATION_VERIFY_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case APPLICATION_VERIFY_STORE_APPLICATIONS:
      return {
        ...state,
        name: "",
        selectedApp: "",
        applications: action.data,
        showApplications: action.data,
      };
    case APPLICATION_VERIFY_STORE_VERSIONS:
      return {
        ...state,
        appInfo: {},
        selectedVersion: "",
        versions: action.data,
        showVersions: action.data,
      };
    case APPLICATION_VERIFY_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case APPLICATION_VERIFY_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateApplicationVerifyData = (data) => {
  return {
    type: APPLICATION_VERIFY_UPDATE_DATA,
    data: data
  }
};


/**
 * get application for verify
 */
export const getApplications = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-application/getApplicationForVerify/`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplications(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all app applications
 */
export const storeApplications = (applications) => {
  return {
    type: APPLICATION_VERIFY_STORE_APPLICATIONS,
    data: applications
  }
};

/**
 * update application status
 */
export const updateApplicationStatus = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: `/api-application/updateApplicationStatus`,
    contentType: "application/json",
    withCredentials: true,
    data: {
      id: data.id,
      status: {code: data.code}
    }
  }).then(
    response => {
      if (response.status === 200) {
        console.info("success audit application");
        dispatch(toggleLoading(false));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_VERIFY_MODAL_SUCCESS_TITLE,
          modalContent: APPLICATION_VERIFY_MODAL_AUDIT_SUCCESS_CONTENT,
          modalOk: APPLICATION_VERIFY_MODAL_OK_LABEL,
          modalCancel: APPLICATION_VERIFY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(getApplications());
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(getApplications());
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        dispatch(sendMessage({
          actorId: data.messageInfo.actorId,
          notifierId: data.messageInfo.notifierId,
          applicationName: data.messageInfo.applicationName,
          version: "",
          result: data.code === "2" ? "审核通过" : "审核不通过",
        }));
      } else {
        console.warn("fail to audit application");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_VERIFY_MODAL_FAIL_TITLE,
          modalContent: APPLICATION_VERIFY_MODAL_AUDIT_FAIL_CONTENT,
          modalOk: APPLICATION_VERIFY_MODAL_OK_LABEL,
          modalCancel: APPLICATION_VERIFY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * get version for verify
 */
export const getVersions = (data) => (dispatch) => {
  console.log(data);
  dispatch(toggleLoading(true));
  axios.get(`/api-application/getVersionForVerify/`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeVersions(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all version
 */
export const storeVersions = (versions) => {
  return {
    type: APPLICATION_VERIFY_STORE_VERSIONS,
    data: versions
  }
};

/**
 * filter application||version data
 */
export const filterData = (data) => (dispatch) => {
  let showApplications = data.applications.filter(application => {
    return application.name.indexOf(data.name) > -1
  });
  dispatch(updateApplicationVerifyData({
    name: "showApplications",
    value: showApplications
  }));
  dispatch(updateApplicationVerifyData({
    name: "selectedApp",
    value: ""
  }));

  let showVersions = data.versions.filter(version => {
    return version.majorVersion.application.name.indexOf(data.name) > -1
  });
  dispatch(updateApplicationVerifyData({
    name: "showVersions",
    value: showVersions
  }));
  dispatch(updateApplicationVerifyData({
    name: "selectedVersion",
    value: ""
  }));
};

/**
 * update version status
 */
export const updateVersionStatus = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: `/api-application/updateVersionStatus`,
    contentType: "application/json",
    withCredentials: true,
    data: {
      id: data.id,
      status: {code: data.code}
    }
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success audit version");
        if (data.code === "2") {
          console.info("app version publish", data.appInfo);
          axios({
            url: `/api-tenant/app/publish`,
            method: "POST",
            data: data.appInfo
          })
        }
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_VERIFY_MODAL_SUCCESS_TITLE,
          modalContent: APPLICATION_VERIFY_MODAL_AUDIT_SUCCESS_CONTENT,
          modalOk: APPLICATION_VERIFY_MODAL_OK_LABEL,
          modalCancel: APPLICATION_VERIFY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(getVersions());
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(getVersions());
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        dispatch(sendMessage({
          actorId: data.messageInfo.actorId,
          notifierId: data.messageInfo.notifierId,
          applicationName: data.messageInfo.applicationName,
          version: `-${data.messageInfo.version}`,
          result: data.code === "2" ? "审核通过" : "审核不通过",
        }));
      } else {
        console.warn("fail to audit version");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_VERIFY_MODAL_FAIL_TITLE,
          modalContent: APPLICATION_VERIFY_MODAL_AUDIT_FAIL_CONTENT,
          modalOk: APPLICATION_VERIFY_MODAL_OK_LABEL,
          modalCancel: APPLICATION_VERIFY_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * send message
 */
export const sendMessage = (data) => (dispatch) => {
  axios({
    method: "post",
    url: "/api-user/notificationObjects",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "actorId": data.actorId,
      "notifierIds": data.notifierId,
      "title": `审核通知`,
      "description": `您提交的应用【${data.applicationName}${data.version}】${data.result}！`,
      "type": "审核消息",
      "selfType": "01",
      "action": data.result,
    }
  }).then(
    response => {
      if (response.status === 200) {
        console.info("success to send a message");
      } else {
        console.error("fail to send a message")
      }
    },
    error => {
      console.error("fail to send a message", error)
    }
  );
};


/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: APPLICATION_VERIFY_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: APPLICATION_VERIFY_TOGGLE_LOADING,
    data: show
  }
};
